module.exports = __webpack_public_path__ + "img/catfood_logo2021.1ee82bf1.png";